/**
 * EtHeader — de kopbalk van de examentraining: zelfde opbouw en stijl als
 * QvHeader (titel | vraagteller | leerling), maar mét de hulpmiddel-iconen
 * rechtsboven zoals leerlingen die van hun digitale examen kennen.
 * Eigen inline-SVG-iconen in TestWisely-stijl.
 */
import React from 'react';
import './EtHeader.css';

export function EtIcoon({ naam, size = 20 }) {
  const p = { width: size, height: size, viewBox: '0 0 24 24', fill: 'none',
    stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' };
  switch (naam) {
    case 'rekenmachine': return (
      <svg {...p}><rect x="5" y="3" width="14" height="18" rx="2" />
        <rect x="8" y="6" width="8" height="4" rx="1" />
        <path d="M8.5 14h.01M12 14h.01M15.5 14h.01M8.5 17.5h.01M12 17.5h.01M15.5 17.5h.01" strokeWidth="2.4" /></svg>);
    case 'formulekaart': return (
      <svg {...p}><rect x="4" y="3" width="16" height="18" rx="2" />
        <path d="M8 8h8M8 12h8M8 16h5" /></svg>);
    case 'meetlat': return (
      <svg {...p}><rect x="2.5" y="9" width="19" height="6.5" rx="1.5" />
        <path d="M6 9v3M9.5 9v2M13 9v3M16.5 9v2M20 9v3" /></svg>);
    case 'geodriehoek': return (
      <svg {...p}><path d="M12 4 21 20H3z" />
        <path d="M12 11v5M9.4 15.5h5.2" /></svg>);
    case 'windroos': return (
      <svg {...p}><circle cx="12" cy="12" r="9" />
        <path d="M12 5v3M12 16v3M5 12h3M16 12h3M12 12l3-6" /></svg>);
    case 'letterplankje': return (
      <svg {...p}><rect x="3" y="5" width="18" height="14" rx="2" />
        <text x="12" y="16" textAnchor="middle" fontSize="10" stroke="none" fill="currentColor" fontWeight="700">ë</text></svg>);
    case 'voorlezen': return (
      <svg {...p}><path d="M4 9v6h4l5 4V5L8 9H4z" />
        <path d="M16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12" /></svg>);
    case 'gebruiker': return (
      <svg {...p}><circle cx="12" cy="8" r="3.5" /><path d="M4.5 20a7.5 7.5 0 0 1 15 0" /></svg>);
    default: return null;
  }
}

function ToolKnop({ naam, label, actief, onClick }) {
  return (
    <button type="button" className={`eth-tool ${actief ? 'actief' : ''}`}
      aria-pressed={!!actief} aria-label={label} title={label} onClick={onClick}>
      <EtIcoon naam={naam} size={20} />
    </button>
  );
}

/**
 * @param {object} p
 * @param {string} p.examName
 * @param {string} p.deelnemer
 * @param {number} p.huidig  0-based
 * @param {number} p.totaal
 * @param {string} [p.punten]   bv. "2p" — puntenaanduiding onder de teller (zoals het examen)
 * @param {Array<{naam:string,label:string,actief?:boolean,onClick:()=>void}>} p.tools
 */
export default function EtHeader({ examName, deelnemer, huidig, totaal, punten, tools = [] }) {
  return (
    <header className="eth-balk">
      <div className="eth-links">
        <span className="eth-titel">{examName}</span>
        <span className="eth-badge">Oefenen</span>
      </div>
      <div className="eth-midden">
        <span className="eth-teller">
          Vraag <b>{huidig + 1}</b> van {totaal}
        </span>
        {punten && <span className="eth-punten">{punten}</span>}
      </div>
      <div className="eth-rechts">
        {tools.map((t) => (
          <ToolKnop key={t.naam + t.label} naam={t.naam} label={t.label}
            actief={t.actief} onClick={t.onClick} />
        ))}
        {tools.length > 0 && <span className="eth-scheiding" />}
        <EtIcoon naam="gebruiker" size={18} />
        <span className="eth-naam">{deelnemer}</span>
      </div>
    </header>
  );
}
